<af-full-table class="w-100 h-100"
               [showImport]="false"
               [showExport]="false"
               [dataSource]="dataSource"
               (tableUpdateListener)="loadMsisdnFraudEntries($event)"
               [columnTranslationPrefixes]="{activationDate: 'msisdnFraudEntry', contactDate: 'msisdnFraudEntry', iin: 'msisdnFraudEntry'}"
               [filterEvent]="tableEvent.filter"
               [pageEvent]="tableEvent.page"
               [sortEvent]="tableEvent.sortBy"
               [filterFields]="filterFields"
               [hasFilterContent]="hasEditAccess"
               [totalElements]="totalElementsForFilter"
               additionalSpinnerIds="msisdnFraudEntries"
               placeholderContext="msisdnFraudEntries"
               emptyStateIconName="ic_empty_state_no_msisdns"
               emptyStateTitleTranslationKey="i18n_af_emptyStateTitleMsisdnFraudEntriesNotAdded"
               [emptyStateSubtitleTranslationKey]="hasEditAccess ? 'i18n_af_emptyStateSubtitleMsisdnFraudEntriesNotAdded' : null"
               [emptyStateButtonLabel]="hasEditAccess ? 'i18n_af_buttonCreateNewMsisdnFraudEntry' : null"
               (emptyStateClickListener)="navigateToCreateEntry()">
    <div FilterContent fxLayout="row" fxLayoutAlign="center center" class="pl-16" fxLayoutGap="16px">
        @if (hasEditAccess) {
            <ui-kit-button [label]="'i18n_af_buttonCreateNewMsisdnFraudEntry' | translate"
                           [removePadding]="true"
                           type="text"
                           iconPosition="left"
                           size="small"
                           buttonType="button"
                           icon="ic_plus_ellipse"
                           [disabled]="!canAddEntry"
                           [matTooltip]="'i18n_af_hintMaxMsisdnFraudEntries' | translate: {count: MAX_ENTRIES}"
                           [matTooltipDisabled]="canAddEntry"
                           (clickListener)="navigateToCreateEntry()"/>
        }
    </div>
</af-full-table>
